/* Desktop guidance mirrors the current picker; it never changes option values. */
(() => {
  const main = document.querySelector('product-info');
  const info = main?.querySelector('[id^="ProductInfo-"]');
  if (!main || !info || document.getElementById('rf-desktop-purchase-bar')) return;
  const desktop = matchMedia('(min-width:750px)');
  const bar = document.createElement('aside');
  bar.id = 'rf-desktop-purchase-bar';
  bar.hidden = true;
  bar.setAttribute('aria-label', 'Product purchase options');
  const inner = document.createElement('div');
  const title = document.createElement('span');
  title.className = 'rf-desktop-purchase-title';
  title.textContent = info.querySelector('h1')?.textContent.trim() || document.querySelector('h1')?.textContent.trim() || '';
  const summary = document.createElement('span');
  summary.className = 'rf-desktop-purchase-selections';
  summary.setAttribute('aria-live', 'polite');
  const description = document.createElement('div');
  description.className = 'rf-desktop-purchase-description';
  description.append(title, summary);
  const price = document.createElement('strong');
  const button = document.createElement('button');
  button.type = 'button';
  const hotcut = document.createElement('button');
  hotcut.type = 'button';
  hotcut.className = 'rf-desktop-hotcut';
  hotcut.textContent = 'Want it hot cut?';
  hotcut.hidden = true;
  inner.append(description, price, button, hotcut);
  bar.append(inner);
  document.body.append(bar);
  let frame = 0;
  let target;
  let purchase;
  let hotcutTarget;
  let chatButton;
  const chatObserver = new MutationObserver(() => schedule());
  const visible = e => !!e && !!e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden';
  const headerHeight = () => Math.max(0, document.querySelector('sticky-header')?.getBoundingClientRect().bottom || 0);
  const update = () => {
    frame = 0;


    window.rfSyncTwillWords?.(main);

    target = null;
    purchase = null;
    hotcutTarget = null;
    const picker = info.querySelector('variant-selects');
    const wholesale = info.querySelector('.rf-wp');
    const fields = [...(wholesale ? wholesale.querySelectorAll('.rf-wp-field') : picker?.querySelectorAll('.product-form__input--pill') || [])];
    const busy = main.dataset.rfChoicesBusy === 'true';
    const missingWholesale = wholesale && fields.find(f => !f.querySelector('input:checked') && visible(f));
    const pending = wholesale ? !!missingWholesale : picker?.dataset.rfOrdered === 'true' && main.dataset.rfChoiceComplete !== 'true';
    const original = wholesale?.querySelector('.rf-wp-submit') || info.querySelector('.product-form__submit');
    let text = '';
    if (pending && wholesale && visible(original)) {
      target = missingWholesale;
      text = 'Choose ' + (target.querySelector('legend')?.textContent.trim().toLowerCase() || 'options');
    } else if (pending && !wholesale) {
      const starter = picker.querySelector('[data-rf-width-starter-ui]');
      const starting = starter && !fields.some(f => f.querySelector('input:checked'));
      const next = fields.find(f => !f.querySelector('input:checked') && f.querySelectorAll('input[type="radio"]').length > 1);
      target = starting ? starter : next;
      const name = starting ? (main.rfWidthStarterMode || 'color or width') : (next?.dataset.rfOptionName || '').trim().toLowerCase();
      text = name ? 'Choose ' + name : '';
    } else if (original && visible(original)) {
      target = original;
      if (!original.disabled) {
        purchase = original;
        text = original.textContent.trim();
      }
    }
    const firstStep = fields.every((field, index) =>
      index === 0 && (wholesale || picker?.dataset.rfPullOpen === 'true') ||
      field.querySelectorAll('input[type="radio"]').length <= 1 || !field.querySelector('input:checked'));
    if (['pat-95-medium-weight-black-cotton-twill','white-twill-tape','natural-twill-tape'].includes((main.dataset.url || '').split('/').pop()) && /^Choose (model|style|weight)$/i.test(text)) text = 'Choose Weight / Thickness';
    if (pending && text) text += firstStep && !main.rfPurchaseGuidanceStarted && !main.rfWidthStarterMode ? ' to get started' : ' to continue';
    const chosen = fields.map(field => {
      const input = field.querySelector('input:checked');
      if (!input) return '';
      if (wholesale) {
        const label = field.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        return label ? [...label.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).map(n => n.textContent).join(' ').trim().replace(/\s+/g, ' ') : input.value;
      }
      const value = input.dataset.rfChoiceLabel || input.value;
      return /number.*ribbon/i.test(field.dataset.rfOptionName || '') && /^\d+$/.test(value) ? value + ' ribbons' : value;
    }).filter(value => value && value !== 'Default Title').join(' · ');
    if (!busy && summary.textContent !== chosen) summary.textContent = chosen;
    if (!busy && summary.hidden !== !chosen) summary.hidden = !chosen;
    if (busy) {text = 'Updating options…'; target = picker || wholesale || original; purchase = null;
    hotcutTarget = null;}
    const overlay = [...document.querySelectorAll('dialog[open],details[open].menu-drawer-container,cart-drawer.active,.search-modal[open]')].some(visible);
    const chat = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part="activator"]');
    if (chat && chat !== chatButton) {
      chatObserver.disconnect();
      chatButton = chat;
      chatObserver.observe(chat, {attributes:true,attributeFilter:['aria-expanded']});
    }
    const show = desktop.matches && pending && !!text && !!target && !overlay && chat?.getAttribute('aria-expanded') !== 'true';
    if (button.textContent !== text) button.textContent = text;
    if (button.disabled !== busy) button.disabled = busy;
    const priceRoot = info.querySelector('.rf-price-sample-row .price') || info.querySelector('.price');
    const currentPrice = priceRoot?.querySelector('.rf-closeout-discount-price') || (priceRoot?.classList.contains('price--on-sale') ? priceRoot.querySelector('.price__sale .price-item--sale') : priceRoot?.querySelector('.price__regular .price-item--regular'));
    const amount = !pending && purchase ? (wholesale?.querySelector('[data-total]') || currentPrice)?.textContent.trim() || '' : '';
    if (price.textContent !== amount) price.textContent = amount;
    if (price.hidden !== !amount) price.hidden = !amount;
    const nativeHotcut = info.querySelector('.hcp-cta');
    hotcutTarget = !pending && !busy && purchase && visible(nativeHotcut) && !nativeHotcut.disabled ? nativeHotcut : null;
    if (hotcut.hidden !== !hotcutTarget) hotcut.hidden = !hotcutTarget;
    const action = pending ? 'choose' : 'purchase';
    if (bar.dataset.rfAction !== action) bar.dataset.rfAction = action;
    if (bar.hidden !== !show) bar.hidden = !show;
    if (document.body.classList.contains('rf-desktop-purchase-visible') !== show) document.body.classList.toggle('rf-desktop-purchase-visible', show);
    const height = bar.offsetHeight + 'px';
    if (show && document.body.style.getPropertyValue('--rf-desktop-purchase-height') !== height) document.body.style.setProperty('--rf-desktop-purchase-height', height);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  button.addEventListener('click', () => {
    // Re-read immediately so a section refresh cannot leave an old cart action.
    update();
    if (purchase && !purchase.disabled && main.dataset.rfChoicesBusy !== 'true') purchase.click();
    else if (target) {
      const wasInitialGuidance=button.textContent.endsWith('to get started');
      main.rfPurchaseGuidanceStarted=true;
      const starter=info.querySelector('[data-rf-width-starter-ui]');
      if(starter&&!main.rfWidthStarterMode&&!info.querySelector('variant-selects input:checked')){
        main.rfWidthStarterMode='color';main.rfApplyChoices?.();update();
      }
      update();
      const summary = info.querySelector('.rf-selection-summary');
      const prompt=wasInitialGuidance?info.querySelector('.rf-order-prompt:not([hidden])'):null;
      const anchor=prompt||target;
      const offset = headerHeight() + (!prompt&&visible(summary)&&getComputedStyle(summary).position==='sticky' ? summary.getBoundingClientRect().height : 0) + 16;
      window.scrollTo({top: Math.max(0, scrollY + anchor.getBoundingClientRect().top - offset), behavior: 'instant'});
      target.querySelector('button,input:not(:disabled),select')?.focus({preventScroll:true});
      schedule();
    }
  });
  hotcut.addEventListener('click', () => {
    update();
    if (hotcutTarget && !hotcutTarget.disabled) hotcutTarget.click();
  });
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  main.addEventListener('rf:choices-updated', schedule);
  main.addEventListener('change', schedule);
  // Read-only synchronization: no reparenting, readiness gating or option mutations.
  new MutationObserver(schedule).observe(main, {subtree:true,childList:true,characterData:!!window.rfSyncTwillWords,attributes:true,attributeFilter:['data-rf-choice-complete','data-rf-choices-busy','disabled','class','hidden']});
  document.addEventListener('toggle', schedule, true);
  desktop.addEventListener('change', schedule);
  schedule();
})();
